import React from 'react';
import PropTypes from 'prop-types';

const VoiceUnlockIcon = ({ className = null }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    className={className}
  >
    <path d="M310-275.38v-409.24h40v409.24h-40ZM460-120v-720h40v720h-40ZM160-427.69v-104.62h40v104.62h-40Zm450 152.31v-409.24h40v409.24h-40Zm150-152.31v-104.62h40v104.62h-40Z" />
  </svg>
);

VoiceUnlockIcon.propTypes = {
  className: PropTypes.string,
};


export default VoiceUnlockIcon;
